import styled from "styled-components";
import ThemeColors from "../../../../themes/colors";

export const Section = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 1rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  width: 100%;
  background-color: ${ThemeColors.Bg300};
`;

export const MainContainer = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  overflow: auto;
`;